export { default } from './MyQR.jsx';
